import {
  ADD_EMPLOYEES, CHANGE_STATUS_EMPLOYEES,
  DELETE_EMPLOYEES,
  EDIT_EMPLOYEES,
  GET_EMPLOYEES,
} from "./employees.types";

export const getEmployees = (params,  noLoad = false) => {
  return {
    type: GET_EMPLOYEES,
    payload: {
      params,
      noLoad
    },
  };
};

export const addEmployee = (body) => {
  return {
    type: ADD_EMPLOYEES,
    payload: {
      body,
    },
  };
};

export const editEmployee = (id, body) => {
  return {
    type: EDIT_EMPLOYEES,
    payload: {
      id,
      body,
    },
  };
};

export const deleteEmployee = (id) => {
  return {
    type: DELETE_EMPLOYEES,
    payload: {
      id,
    },
  };
};

export const changeStatus = (id, body) => {
  return {
    type: CHANGE_STATUS_EMPLOYEES,
    payload: {
      id,
      body,
    },
  };
};
